import { Grid, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useEffect, useRef, useState } from 'react';
import { onEditAction } from '../../core/audit';
import {
  CollectionTable,
  Column,
  FilterControl,
  auditColumn,
  deleteColumn,
  editColumn,
  shimColumn,
} from '../../core/collections';
import { Auto, Text } from '../../core/controls';
import {
  Expansion,
  ExpansionDetails,
  ExpansionSummary,
} from '../../core/expansion';
import { NcnbReasonsApi } from '../../core/ncnb-reasons-api';
import { orange } from '../../core/theme';
import { UndoRedo } from '../../core/undo-redo';
import { isAuditReviewWorkflow, isReviewWorkflow } from '../../core/workflow-api';
import { isResolved } from '../../core/worksheets';
import { truncateSpan } from '../../core';

export function NCNBReaonsForm(api: NcnbReasonsApi) {
  const form = useRef(api.form).current;
  const { reason, comment } =
    form.controls;


  return (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      style={{
        width: '100%',
        paddingLeft: '12px',
        paddingTop: '6px',
        paddingBottom: '8px',
      }}
    >
      
  
      <Grid item xs={5}>
        <Auto {...reason} />
      </Grid>
      <Grid item xs={5}>
        <Text {...comment} />
      </Grid>
    </Grid>
  );
}

export function NCNBCollection(api: NcnbReasonsApi) {
  const { list, context } = api;
  const { auditNCNB } = context.config;

  const isReview = isAuditReviewWorkflow();
  const actions = isReview
    ? [
        auditColumn(
          onEditAction(
            'Edit NCNB Audit Comments',
            () => list.actions.refresh(),
            false,
            auditNCNB
          )
        ),
      ]
    : [];

  const columns: Column[] = [

    {
      name: 'reasonCode',
      label: 'Reason',
      component: (e) => truncateSpan(e.value.reasonCode, '80px'),
    },
    {
      name: 'description',
      label: 'Description',
      component: (e) => truncateSpan(e.value.description, '80px'),
    },
    {
      name: 'comments',
      label: 'Comments',
      component: (e) => truncateSpan(e.value.comments, '80px'),
    },
    ...actions,
    editColumn(
      (e) => api.editItem(e.value),
      (v) => !isResolved(v)
    ),
    deleteColumn(
      (e) => api.removeItem(e.value),
      (v) => !isResolved(v)
    ),
    shimColumn(),
  ];

  const values = list.data((s) => s.values);
  const [expanded, setExpanded] = useState(values.length > 0);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (!clicked && !expanded) {
      setExpanded(values.length > 0);
    }
  });

  const onClicked = () => {
    setExpanded(!expanded);
    setClicked(true);
  };


  return (
    <Expansion expanded={expanded}>
      <ExpansionSummary onClick={onClicked} expandIcon={<ExpandMoreIcon id="ncnbreasons_expend_more"/>}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: 24,
            alignItems: 'center',
            flexWrap: 'nowrap',
          }}
        >
          <Typography variant="subtitle2">{`NO CODE / NO BILL ${
            values.length ? '- ' + values.length : ''
          }`}</Typography>
          <div style={{ display: 'flex', flex: 1, flexGrow: 1 }} />

          <div onClick={(e) => e.stopPropagation()}>
            <UndoRedo api={api.listChanges} htmlColor={orange} label='ncnbreasons' />
          </div>

          <FilterControl api={list} />
        </div>
      </ExpansionSummary>
      <ExpansionDetails>
        <CollectionTable
          readonly={api.context.readonly}
          columns={columns}
          api={list}
          containerProps={{ elevation: 0 }}
          name='ncnbreasons_table'
          label={`NO CODE / NO BILL ${values.length ? '- ' + values.length : ''}`}
        />
      </ExpansionDetails>
    </Expansion>
  );
}
